import {InternalStaticImageType} from '../StaticImage/InternalStaticImageType.enum';
import {StaticImage} from '../StaticImage/StaticImage';

export interface LoadingProps {
  spinSpeed?: string;
  size?: number;
}

export function Loading({spinSpeed = '.8', size = 32}: LoadingProps) {
  return (
    <StaticImage
      className="animate-spin"
      imageType={InternalStaticImageType.LoadingStatic}
      style={{
        animation: spinSpeed ? `spin ${spinSpeed}s linear infinite` : undefined,
        height: size,
        width: size,
      }}
    />
  );
}
